import React from 'react';
import { Star, CheckCircle2, ShieldCheck, Lock, CreditCard, Mail, Gift, Clock3, ChevronDown } from 'lucide-react';
import { PriceDisplay } from '../components/PriceDisplay';
import { CTAButton } from '../components/CTAButton';
import { SectionTitle } from '../components/SectionTitle';
const testimonials = [{
  name: 'Mariela, 52',
  text: 'Sentía que cada vez me costaba más organizarme y terminaba comiendo cualquier cosa. Con esta guía empecé a resolver mis comidas de forma mucho más simple.'
}, {
  name: 'Andrea, 48',
  text: 'Lo que más me gustó es que no se siente como una dieta. Son ideas reales, fáciles y que de verdad te ayudan a sentirte más liviana.'
}, {
  name: 'Patricia, 56',
  text: 'Los desayunos y meriendas altas en proteína me ayudaron muchísimo con la ansiedad y con la energía durante el día.'
}, {
  name: 'Silvia, 50',
  text: 'Está todo explicado de forma clara y práctica. Ideal si querés comer mejor sin volverte loca contando calorías.'
}, {
  name: 'Mónica, 47',
  text: 'Me encantó el menú y el planner. Ya no arranco la semana improvisando ni pensando qué cocinar.'
}, {
  name: 'Gabriela, 54',
  text: 'Sentí que por fin encontré una forma más realista de cuidarme en esta etapa, sin extremos y sin culpa.'
}];
const faqs = [{
  q: '¿Qué voy a recibir exactamente?',
  a: 'Vas a recibir la guía digital Comer mejor después de los 45/50, el recetario funcional, el menú práctico y el planner de hábitos incluidos en esta oferta especial.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Una vez realizada la compra, recibís acceso digital inmediato para verlo y descargarlo desde tu celular, tablet o computadora.'
}, {
  q: '¿Necesito hacer una dieta estricta?',
  a: 'No. Esta guía fue creada justamente para ayudarte a comer mejor sin dietas extremas, con un enfoque simple, realista y fácil de sostener.'
}, {
  q: '¿Es solo para mujeres en menopausia?',
  a: 'No exclusivamente. También es ideal para mujeres 45+ y 50+ que sienten que suben de peso más fácil, tienen menos energía o quieren volver a comer mejor sin complicarse.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Tenés 7 días para probar el material. Si sentís que no era lo que esperabas, podés solicitar tu reembolso.'
}];
export function LandingPage() {
  return <div className="min-h-screen bg-[#fffaf7] text-stone-800" data-id="element-8">
      <div className="sticky top-0 z-50 border-b border-rose-200 bg-stone-950 px-4 py-3 text-center text-sm font-semibold text-white" data-id="element-9">
        🔥 HOY SOLAMENTE: 50% OFF + BONOS DIGITALES GRATIS + ACCESO INMEDIATO
      </div>

      <section className="relative overflow-hidden border-b border-rose-100 bg-gradient-to-b from-rose-50 via-[#fffaf7] to-[#fffaf7]" data-id="element-10">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:grid-cols-2 md:px-6 md:py-20" data-id="element-11">
          <div className="flex flex-col justify-center" data-id="element-12">
            <div className="mb-5 inline-flex w-fit items-center rounded-full border border-rose-200 bg-white px-4 py-2 text-sm font-medium text-stone-700 shadow-sm" data-id="element-13">
              <Star className="mr-2 h-4 w-4 fill-current text-amber-400" data-id="element-14" />
              4.9/5 valorado por clientas felices
            </div>
            <h1 className="max-w-xl text-4xl font-bold leading-tight tracking-tight text-stone-900 md:text-6xl" data-id="element-15">
              Comer mejor después de los 45/50{' '}
              <span className="text-rose-600" data-id="element-16">sin dietas extremas</span>
            </h1>
            <div className="mt-6 flex justify-center md:justify-start" data-id="element-17">
              <img src="https://cdn.magicpatterns.com/uploads/4YZkGfetnvTxF25AEW4aKk/argentino_idioma_Crea_202604031727.png" alt="Portada de la guía Comé Mejor Después de los 45/50" className="w-full max-w-xs rounded-2xl shadow-xl shadow-rose-100 md:max-w-sm" data-id="element-18" />
            </div>
            <p className="mt-5 max-w-xl text-lg leading-8 text-stone-600 md:text-xl" data-id="element-19">
              Descubrí la guía digital pensada para mujeres 45+ y 50+ que
              quieren verse y sentirse mejor, recuperar energía, comer más rico
              y organizar sus comidas con un plan simple, realista y fácil de
              sostener.
            </p>
            <div className="mt-6 grid gap-3 text-sm text-stone-700 sm:grid-cols-2" data-id="element-20">
              {['Acceso inmediato', 'Formato digital compatible con celular, tablet y computadora', 'Recetas altas en proteína y menús fáciles', 'Garantía de 7 días'].map(item => <div key={item} className="flex items-start gap-2 rounded-xl bg-white/80 p-3 shadow-sm ring-1 ring-rose-100" data-id="element-21">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 text-emerald-600" data-id="element-22" />
                  <span data-id="element-23">{item}</span>
                </div>)}
            </div>
            <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-24">
              <CTAButton data-id="element-25">QUIERO ACCEDER AHORA</CTAButton>
              <div className="text-sm text-stone-600" data-id="element-26">
                Oferta de hoy por solo{' '}
                <PriceDisplay amountARS={15999} className="font-bold text-stone-900" data-id="element-27" />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center" data-id="element-28">
            <div className="relative w-full max-w-lg rounded-[2rem] border border-rose-100 bg-white p-4 shadow-2xl shadow-rose-100" data-id="element-29">
              <div className="absolute -right-3 -top-3 rounded-full bg-amber-400 px-4 py-2 text-sm font-bold text-stone-900 shadow-lg" data-id="element-30">
                50% OFF
              </div>
              <div className="rounded-[1.5rem] bg-gradient-to-br from-rose-100 via-orange-50 to-emerald-50 p-5" data-id="element-31">
                <div className="aspect-[4/5] rounded-[1.25rem] border border-white/70 bg-white/70 p-6 shadow-inner backdrop-blur" data-id="element-32">
                  <img src="https://cdn.magicpatterns.com/uploads/4YZkGfetnvTxF25AEW4aKk/argentino_idioma_Crea_202604031727.png" alt="Portada de la guía Comé Mejor Después de los 45/50" className="h-full w-full rounded-[1rem] object-cover shadow-sm" data-id="element-33" />
                </div>
              </div>
              <div className="mt-4 flex flex-wrap gap-2" data-id="element-34">
                {['Mujeres 45+', 'Más energía', 'Sin dietas extremas', 'Fácil de aplicar'].map(tag => <span key={tag} className="rounded-full bg-stone-100 px-3 py-1 text-xs font-semibold text-stone-700" data-id="element-35">
                    {tag}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-14 md:px-6 md:py-20" data-id="element-36">
        <div className="mx-auto max-w-3xl rounded-[2rem] bg-white p-6 shadow-xl shadow-stone-100 ring-1 ring-stone-100 md:p-10" data-id="element-37">
          <div className="prose prose-stone max-w-none prose-p:leading-8" data-id="element-38">
            <h2 className="!mb-6 !text-3xl !font-bold !text-stone-900" data-id="element-39">
              Seguro te pasó esto:
            </h2>
            <p data-id="element-40">
              Querés comer mejor, sentirte más liviana, recuperar energía y
              volver a verte bien… pero sentís que cada vez te cuesta más
              sostener hábitos simples.
            </p>
            <p data-id="element-41">
              Probaste empezar muchas veces, pero terminás cayendo en lo mismo.
            </p>
            <p data-id="element-42">Las “soluciones” que suelen aparecer por todos lados son:</p>
            <div className="my-6 grid gap-3" data-id="element-43">
              {['complicadas', 'restrictivas', 'difíciles de sostener', 'llenas de reglas imposibles', 'o tan extremas que duran solo unos días antes de que abandones'].map(item => <div key={item} className="flex items-center gap-3 rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-red-800" data-id="element-44">
                  <span className="text-lg" data-id="element-45">❌</span>
                  <span data-id="element-46">{item}</span>
                </div>)}
            </div>
            <p data-id="element-47">Y mientras tanto seguís pensando:</p>
            <div className="my-6 space-y-2 text-stone-700" data-id="element-48">
              {['“Ya no me funciona hacer lo de antes”', '“No tengo tiempo para planificar”', '“No sé qué preparar para comer mejor”', '“Me cuesta controlar el picoteo y los antojos”', '“No quiero vivir a dieta”'].map(item => <p key={item} className="rounded-xl bg-stone-50 px-4 py-3 italic" data-id="element-49">
                  {item}
                </p>)}
            </div>
            <p data-id="element-50">La realidad es que el problema no sos vos.</p>
            <p data-id="element-51">
              El problema es que nadie te enseñó una forma simple, rica y
              práctica de comer mejor en esta etapa, sin culpa, sin obsesión y
              sin sentir que estás castigándote con comida “de dieta”.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#fff4f1] px-4 py-14 md:px-6 md:py-20" data-id="element-52">
        <div className="mx-auto max-w-6xl" data-id="element-53">
          <div className="grid gap-8 md:grid-cols-2" data-id="element-54">
            <div className="rounded-[2rem] bg-white p-6 shadow-lg ring-1 ring-red-100 md:p-8" data-id="element-55">
              <h3 className="mb-6 text-2xl font-bold text-stone-900" data-id="element-56">
                Si hoy sentís que:
              </h3>
              <div className="space-y-3" data-id="element-57">
                {['te cansaste de improvisar qué comer cada día', 'subís de peso más fácil y no entendés por qué', 'tenés menos energía y más antojos', 'necesitás ideas simples para desayunos, almuerzos, cenas y meriendas', 'querés opciones más livianas sin renunciar al sabor', 'buscás una forma realista de cuidarte sin dietas extremas'].map(item => <div key={item} className="flex items-start gap-3 rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-red-900" data-id="element-58">
                    <span data-id="element-59">❌</span>
                    <span data-id="element-60">{item}</span>
                  </div>)}
              </div>
            </div>
            <div className="rounded-[2rem] bg-white p-6 shadow-lg ring-1 ring-emerald-100 md:p-8" data-id="element-61">
              <h3 className="mb-6 text-2xl font-bold text-stone-900" data-id="element-62">
                Entonces esta guía fue hecha para vos.
              </h3>
              <div className="space-y-3" data-id="element-63">
                {['guía práctica para comer mejor después de los 45/50', 'planes simples de alimentación y menús fáciles', 'recetas altas en proteína para sentir más saciedad y energía', 'hábitos claros para organizarte sin complicarte', 'material digital para consultar cuando quieras', 'enfoque realista, simple y fácil de aplicar desde hoy'].map(item => <div key={item} className="flex items-start gap-3 rounded-2xl border border-emerald-100 bg-emerald-50 px-4 py-3 text-emerald-900" data-id="element-64">
                    <span data-id="element-65">✅</span>
                    <span data-id="element-66">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-14 md:px-6 md:py-20" data-id="element-67">
        <SectionTitle eyebrow="Tu nueva etapa" title="Imaginate sentirte más liviana, con más energía y con tus comidas resueltas" subtitle="Imaginate abrir tu celular y saber exactamente qué comer sin perder tiempo buscando ideas en mil lugares distintos. Imaginate volver a disfrutar la comida, sentir más saciedad y tener una rutina simple que sí podés sostener." data-id="element-68" />
        <div className="mx-auto grid max-w-5xl gap-4 md:grid-cols-2" data-id="element-69">
          {['Desayunos y meriendas que te ayuden a arrancar mejor el día', 'Comidas simples para dejar de improvisar', 'Más variedad sin sentirte en una dieta eterna', 'Hábitos concretos para sentirte mejor semana a semana'].map(item => <div key={item} className="rounded-3xl border border-rose-100 bg-white p-6 shadow-sm" data-id="element-70">
              <p className="text-base leading-7 text-stone-700" data-id="element-71">{item}</p>
            </div>)}
        </div>
      </section>

      <section className="bg-white px-4 py-14 md:px-6 md:py-20" data-id="element-72">
        <div className="mx-auto max-w-6xl" data-id="element-73">
          <SectionTitle eyebrow="Qué vas a recibir hoy" title="Un pack digital completo para ayudarte a comer mejor después de los 45/50" subtitle="Todo pensado para que puedas pasar de la confusión a la claridad, con materiales simples, prácticos y fáciles de aplicar en tu vida real." data-id="element-74" />
          <div className="grid gap-6 md:grid-cols-2" data-id="element-75">
            {[{
            title: 'Guía principal: Comer mejor después de los 45/50',
            desc: 'Una guía digital clara y práctica para entender qué cambiar en esta etapa y cómo comer mejor sin dietas extremas ni reglas imposibles.'
          }, {
            title: 'Recetario funcional alto en proteína',
            desc: 'Recetas simples, saciantes y fáciles de preparar para desayunos, almuerzos, cenas, meriendas y snacks más inteligentes.'
          }, {
            title: 'Menú práctico de 7 días',
            desc: 'Una estructura lista para seguir, repetir, adaptar y usar como base para dejar de improvisar cada semana.'
          }, {
            title: 'Planner de hábitos',
            desc: 'Una herramienta imprimible y digital para organizar comidas, registrar energía y sostener hábitos sin obsesionarte.'
          }].map((item, idx) => <div key={item.title} className="rounded-[2rem] border border-stone-100 bg-[#fffaf7] p-6 shadow-sm" data-id="element-76">
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-100 text-lg font-bold text-rose-700" data-id="element-77">
                  {idx + 1}
                </div>
                <h3 className="text-xl font-bold text-stone-900" data-id="element-78">
                  {item.title}
                </h3>
                <p className="mt-3 text-base leading-7 text-stone-600" data-id="element-79">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="bg-stone-950 px-4 py-14 text-white md:px-6 md:py-20" data-id="element-80">
        <div className="mx-auto max-w-6xl" data-id="element-81">
          <SectionTitle eyebrow="Bonos incluidos" title="Además, hoy te llevás estos bonos de regalo" subtitle="Una oferta pensada para darte más estructura, más claridad y más facilidad para aplicar todo desde el primer día." data-id="element-82" />
          <div className="grid gap-5" data-id="element-83">
            {[{
            title: '🎁 Bono #1: Planner semanal de comidas',
            desc: 'Organizá tus comidas de forma simple y dejá de improvisar cada día.',
            value: '$9.000 ARS — HOY GRATIS'
          }, {
            title: '🎁 Bono #2: Mini recetario de desayunos y meriendas altas en proteína',
            desc: 'Ideas prácticas para sentir más saciedad, sostener tu energía y resolver mejor tus momentos clave del día.',
            value: '$12.000 ARS — HOY GRATIS'
          }, {
            title: '🎁 Bono #3: Guía rápida de hábitos 45+',
            desc: 'Un complemento ideal para sumar pequeños cambios que te ayuden a sentirte mejor y mantenerte motivada.',
            value: '$10.000 ARS — HOY GRATIS'
          }].map(bonus => <div key={bonus.title} className="rounded-[2rem] border border-amber-300/30 bg-white/5 p-6 backdrop-blur" data-id="element-84">
                <div className="flex items-start gap-4" data-id="element-85">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-amber-400 text-stone-950" data-id="element-86">
                    <Gift className="h-6 w-6" data-id="element-87" />
                  </div>
                  <div data-id="element-88">
                    <h3 className="text-xl font-bold" data-id="element-89">{bonus.title}</h3>
                    <p className="mt-2 text-white/80" data-id="element-90">{bonus.desc}</p>
                    <p className="mt-3 font-semibold text-amber-300" data-id="element-91">
                      Valor: {bonus.value}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="mt-8 rounded-[2rem] border border-amber-300/40 bg-amber-50 p-6 text-stone-900 shadow-xl" data-id="element-92">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-amber-700" data-id="element-93">
              Valor total del paquete
            </p>
            <div className="mt-4 grid gap-2 text-base md:grid-cols-2" data-id="element-94">
              <p data-id="element-95">Guía principal: $15.000 ARS</p>
              <p data-id="element-96">Bono 1: $3.000 ARS</p>
              <p data-id="element-97">Bono 2: $5.000 ARS</p>
              <p data-id="element-98">Bono 3: $10.000 ARS</p>
            </div>
            <p className="mt-4 text-2xl font-bold" data-id="element-99">VALOR TOTAL: $33.000 ARS</p>
            <p className="mt-3 text-lg" data-id="element-100">Pero hoy no vas a pagar eso.</p>
          </div>
        </div>
      </section>

      <section className="px-4 py-14 md:px-6 md:py-20" data-id="element-101">
        <div className="mx-auto max-w-5xl rounded-[2rem] border border-rose-200 bg-gradient-to-br from-white to-rose-50 p-6 shadow-2xl shadow-rose-100 md:p-10" data-id="element-102">
          <div className="grid gap-8 md:grid-cols-[1.15fr_0.85fr] md:items-center" data-id="element-103">
            <div data-id="element-104">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-rose-600" data-id="element-105">
                Oferta especial
              </p>
              <h2 className="mt-3 text-3xl font-bold tracking-tight text-stone-900 md:text-5xl" data-id="element-106">
                Hoy podés llevarte todo por solo{' '}
                <PriceDisplay amountARS={15999} className="text-rose-600" data-id="element-107" />
              </h2>
              <div className="mt-6 space-y-3 text-base text-stone-700" data-id="element-108">
                {['50% OFF por tiempo limitado', 'acceso inmediato', 'bonos incluidos sin costo extra'].map(item => <div key={item} className="flex items-start gap-3" data-id="element-109">
                    <CheckCircle2 className="mt-0.5 h-5 w-5 text-emerald-600" data-id="element-110" />
                    <span data-id="element-111">{item}</span>
                  </div>)}
              </div>
              <div className="mt-6 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-4 text-amber-900" data-id="element-112">
                ⚠️ Esta oferta promocional es por tiempo limitado y puede
                cerrarse en cualquier momento. Si estás viendo esta página
                ahora, aprovechá antes de que vuelva a su precio normal.
              </div>
            </div>
            <div className="rounded-[2rem] bg-white p-6 shadow-lg ring-1 ring-stone-100" data-id="element-113">
              <div className="mb-4 inline-flex rounded-full bg-rose-600 px-4 py-2 text-sm font-bold text-white" data-id="element-114">
                DESCUENTO ACTIVO
              </div>
              <div className="mb-2 text-sm text-stone-500 line-through" data-id="element-115">
                Antes $33.000 ARS
              </div>
              <div className="text-4xl font-extrabold text-stone-900 md:text-5xl" data-id="element-116">
                <PriceDisplay amountARS={15999} data-id="element-117" />
              </div>
              <p className="mt-2 text-sm text-stone-500" data-id="element-118">
                Pago único • Acceso inmediato
              </p>
              <div className="mt-6" data-id="element-119">
                <CTAButton className="md:w-full" data-id="element-120">
                  QUIERO MI GUÍA AHORA
                </CTAButton>
              </div>
              <div className="mt-5 grid gap-3 text-sm text-stone-700" data-id="element-121">
                <div className="flex items-center gap-3" data-id="element-122">
                  <Lock className="h-4 w-4 text-emerald-600" data-id="element-123" /> 🔒 Compra segura
                </div>
                <div className="flex items-center gap-3" data-id="element-124">
                  <CreditCard className="h-4 w-4 text-emerald-600" data-id="element-125" /> 💳 Pago
                  protegido
                </div>
                <div className="flex items-center gap-3" data-id="element-126">
                  <Mail className="h-4 w-4 text-emerald-600" data-id="element-127" /> 📩 Acceso
                  digital inmediato
                </div>
                <div className="flex items-center gap-3" data-id="element-128">
                  <ShieldCheck className="h-4 w-4 text-emerald-600" data-id="element-129" /> 🛡️
                  Garantía de satisfacción de 7 días
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-14 md:px-6 md:py-20" data-id="element-130">
        <div className="mx-auto max-w-4xl rounded-[2rem] border border-emerald-100 bg-emerald-50 p-6 shadow-sm md:p-10" data-id="element-131">
          <div className="flex items-center gap-3 text-emerald-700" data-id="element-132">
            <ShieldCheck className="h-7 w-7" data-id="element-133" />
            <h2 className="text-2xl font-bold text-stone-900 md:text-3xl" data-id="element-134">
              Probalo sin riesgo durante 7 días
            </h2>
          </div>
          <p className="mt-5 text-base leading-8 text-stone-700" data-id="element-135">
            Estamos convencidos de que este material puede ayudarte a comer
            mejor de una forma más práctica, realista y sostenible.
          </p>
          <p className="mt-4 text-base leading-8 text-stone-700" data-id="element-136">
            Por eso, si dentro de los primeros 7 días sentís que no era para
            vos, podés pedir la devolución total de tu dinero.
          </p>
          <div className="mt-5 grid gap-3 sm:grid-cols-3" data-id="element-137">
            {['Sin vueltas', 'Sin complicaciones', 'Sin riesgo para vos'].map(item => <div key={item} className="rounded-2xl bg-white px-4 py-4 text-center font-semibold text-stone-800 shadow-sm" data-id="element-138">
                  {item}
                </div>)}
          </div>
        </div>
      </section>

      <section className="bg-[#fff7f4] px-4 py-14 md:px-6 md:py-20" data-id="element-139">
        <div className="mx-auto max-w-6xl" data-id="element-140">
          <SectionTitle eyebrow="Prueba social" title="Lo que están diciendo nuestras lectoras" subtitle="Testimonios de mujeres que buscaban una forma más simple y realista de cuidarse en esta etapa." data-id="element-141" />
          <div className="columns-1 gap-5 md:columns-2 lg:columns-3" data-id="element-142">
            {testimonials.map(testimonial => <div key={testimonial.name} className="mb-5 break-inside-avoid rounded-[2rem] bg-white p-6 shadow-md ring-1 ring-stone-100" data-id="element-143">
                <div className="mb-4 flex items-center gap-1 text-amber-400" data-id="element-144">
                  {Array.from({
                length: 5
              }).map((_, i) => <Star key={i} className="h-4 w-4 fill-current" data-id="element-145" />)}
                </div>
                <p className="text-base leading-7 text-stone-700" data-id="element-146">
                  “{testimonial.text}”
                </p>
                <div className="mt-5 flex items-center gap-3" data-id="element-147">
                  <div className="flex h-11 w-11 items-center justify-center rounded-full bg-rose-100 font-bold text-rose-700" data-id="element-148">
                    {testimonial.name.charAt(0)}
                  </div>
                  <p className="font-semibold text-stone-900" data-id="element-149">
                    {testimonial.name}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <section className="px-4 py-14 md:px-6 md:py-20" data-id="element-150">
        <div className="mx-auto max-w-4xl" data-id="element-151">
          <SectionTitle eyebrow="Preguntas frecuentes" title="Resolvé tus dudas antes de empezar" data-id="element-152" />
          <div className="space-y-4" data-id="element-153">
            {faqs.map(faq => <details key={faq.q} className="group rounded-[1.5rem] border border-stone-200 bg-white p-5 shadow-sm open:border-rose-200 open:bg-rose-50/40" data-id="element-154">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left text-lg font-semibold text-stone-900" data-id="element-155">
                  {faq.q}
                  <ChevronDown className="h-5 w-5 shrink-0 text-stone-500 transition group-open:rotate-180" data-id="element-156" />
                </summary>
                <p className="mt-4 text-base leading-7 text-stone-700" data-id="element-157">
                  {faq.a}
                </p>
              </details>)}
          </div>
        </div>
      </section>

      <section className="bg-stone-950 px-4 py-14 text-white md:px-6 md:py-20" data-id="element-158">
        <div className="mx-auto max-w-4xl text-center" data-id="element-159">
          <Clock3 className="mx-auto h-10 w-10 text-rose-400" data-id="element-160" />
          <h2 className="mt-5 text-3xl font-bold tracking-tight md:text-5xl" data-id="element-161">
            Hoy podés seguir postergando… o empezar a cuidarte de una forma más
            simple
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-lg leading-8 text-white/80" data-id="element-162">
            Podés seguir improvisando comidas, arrancando cada semana de cero y
            sintiendo que necesitás hacer algo extremo para volver a verte y
            sentirte bien… o podés aprovechar esta oportunidad y tener desde hoy
            una guía clara, práctica y lista para ayudarte a comer mejor después
            de los 45/50.
          </p>
          <div className="mt-8" data-id="element-163">
            <CTAButton data-id="element-164">SÍ, QUIERO ACCESO INMEDIATO</CTAButton>
          </div>
        </div>
      </section>

      <footer className="border-t border-stone-200 bg-white px-4 py-8 text-center text-sm text-stone-500 md:px-6" data-id="element-165">
        <p data-id="element-166">© 2026 Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-167">
          Este producto es digital. El acceso se entrega luego de completar la
          compra.
        </p>
      </footer>
    </div>;
}